export default "__VITE_ASSET__d96e27fe__"